import styled, { css } from "styled-components";
import { rhytPanelHeight } from "../../score-display/parameters";
import { IStyledButtonProps } from "./interfaces";

export const StyledRhythmPanel = styled.div`
    text-align: center;
    height: ${rhytPanelHeight}px;
    position: relative;
    z-index: 2;
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const StyledButton = styled.button<IStyledButtonProps>`
    height: 60px;
    width: 60px;
    display: inline-block;
    margin: 5px 8px;
    padding: 0;
    outline: none;
    background-color: white;
    box-shadow: 0 0 0 2px black;
    border-radius: 30px;
    border: none;
    cursor: pointer;
    font-size: 22px;
    position: relative;
    vertical-align: top;
    transition: 300ms;
    svg {
        line {
            stroke: black;
            transition: 300ms;
        }
        path {
            fill: black;
            transition: 300ms;
        }
    }

    ${p =>
        p.active &&
        css`
            background-color: ${p.theme.c.info};
            svg {
                line {
                    stroke: white;
                }
                path {
                    fill: white;
                }
            }
            color: white;
        `}

    .i-arrowback {
        font-size: 44px;
        color: black;
        margin-top: 3px;
        display: block;
    }

    &:active {
        background-color: ${p => p.theme.c.active};
        transform: scale(1.08);
        color: white;
        .i-arrowback {
            color: ${p => p.theme.c.whiteOnActive};
        }
        svg {
            line {
                stroke: ${p => p.theme.c.whiteOnActive};
            }
            path {
                fill: ${p => p.theme.c.whiteOnActive};
            }
        }
    }

    &:disabled {
        opacity: 0.5;
        pointer-events: none;
    }
`;

export const Truplet = styled.button`
    position: absolute;
    top: 64px;
    left: 28px;
    width: 18px;
    height: 18px;
    padding: 0;
    border-radius: 9px;
    box-shadow: 0 0 0 2px black;
    line-height: normal;
    font-size: 15px;
    cursor: pointer;
    background-color: white;
    outline: none;
    border: none;
    &.Active {
        background-color: ${p => p.theme.c.info};
    }
    i {
        font-size: 18px;
        color: black;
    }
`;

export const ButtonContainer = styled.div`
    display: inline-block;
    position: relative;
`;

export const TieContainer = styled.div`
    position: relative;
    top: 10px;
    left: 1px;
`;

export const TutorialWrapper = styled.div`
    margin-left: 8px;
`;
